// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"266cc8e5","453":"02da8ab2","516":"d3105934"}[chunkId] + ".chunk.js";
};